export function normalizeUrl(url) {
    return url.endsWith('/') ? url : `${url}/`;
}
